import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { getTokens } from '../../../styles/tokens';
import { socketConnection } from "../../../services/socket";
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { AuthContext } from '../../../context/Auth/AuthContext';
import { SocketContext } from '../../../context/Socket/SocketContext';

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    total: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 12,
      padding: '12px 16px',
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.md,
      backgroundColor: t.muted,
      fontFamily: t.font,
    },
    totalLabel: {
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      color: t.textSecondary,
    },
    totalValue: {
      fontSize: 24,
      fontWeight: 700,
      letterSpacing: '-0.02em',
      fontVariantNumeric: 'tabular-nums',
      color: t.text,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 14,
      marginTop: 20,
      fontFamily: t.font,
    },
    // o leitor de QR precisa de módulos escuros sobre fundo claro, também no tema escuro
    qr: {
      padding: 14,
      lineHeight: 0,
      backgroundColor: '#ffffff',
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.md,
      '& svg': { display: 'block', maxWidth: '100%', height: 'auto' },
    },
    action: { width: 'min(100%, 320px)' },
    copied: { color: t.status.ok.fg },
    hint: {
      maxWidth: 420,
      margin: 0,
      fontSize: 13,
      lineHeight: 1.5,
      textAlign: 'center',
      color: t.textSecondary,
    },
  };
});

function CheckoutSuccess(props) {

  const { pix } = props;
  const classes = useStyles();
  const socketManager = useContext(SocketContext);
  const [pixString,] = useState(pix?.qrcode?.qrcode || '');
  const [stripeURL,] = useState(pix.stripeURL);
  const [asaasURL,] = useState(pix.asaasURL);
  const [mercadopagoURL,] = useState(pix.mercadopagoURL);
  const [valorext,] = useState(pix.valorext);
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  const { dateToClient } = useDate();
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  useEffect(() => {
    const onCompanyPayment = (data) => {
      if (data.action === "CONCLUIDA") {
        toast.success(`Sua licença foi renovada até ${dateToClient(data.company.dueDate)}!`);
        setTimeout(() => {
          history.push("/");
        }, 4000);
      }
    }
    socket.on(`company-${companyId}-payment`, onCompanyPayment);
    
    return () => {
      socket.disconnect();
    }
  }, [history, dateToClient, socketManager]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  return (
    <React.Fragment>
      <div className={classes.total}>
        <span className={classes.totalLabel}>Total</span>
        <strong className={classes.totalValue}>
          R$ {valorext.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
        </strong>
      </div>

      <div className={classes.content}>
        {pixString && (
          <>
            <div className={classes.qr}>
              <QRCode value={pixString} size={224} />
            </div>
            <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
              <Button
                className={`${classes.action} ${copied ? classes.copied : ''}`}
                variant="outlined"
                type="button"
                startIcon={copied ? <CheckCircleOutlineIcon /> : <FileCopyOutlinedIcon />}
              >
                {copied ? 'Copiado' : 'Copiar código QR PIX'}
              </Button>
            </CopyToClipboard>
            <p className={classes.hint}>
              Para finalizar, basta realizar o pagamento escaneando ou colando o
              código Pix acima ou escolha Pagar com Cartão de Crédito abaixo.
            </p>
          </>
        )}

        {stripeURL && (
          <Button
            className={classes.action}
            variant="outlined"
            type="button"
            endIcon={<OpenInNewIcon />}
            onClick={() => window.open(stripeURL, '_blank')}
          >
            Pagar com Cartão de Crédito
          </Button>
        )}

        {mercadopagoURL && (
          <Button
            className={classes.action}
            variant="outlined"
            type="button"
            endIcon={<OpenInNewIcon />}
            onClick={() => window.open(mercadopagoURL, '_blank')}
          >
            Pagar com MercadoPago
          </Button>
        )}

        {asaasURL && (
          <Button
            className={classes.action}
            variant="outlined"
            type="button"
            endIcon={<OpenInNewIcon />}
            onClick={() => window.open(asaasURL, '_blank')}
          >
            Pagar com Asaas
          </Button>
        )}
      </div>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
